
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { RetentionPolicyFormValues } from '@/components/admin/certificates/retention/schemas/retentionPolicySchema';

export function usePolicyCreation({ setIsAddDialogOpen }: { setIsAddDialogOpen: (open: boolean) => void }) {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const createPolicyMutation = async (data: RetentionPolicyFormValues) => {
    setIsSubmitting(true);
    try {
      // Save policy to database
      const { error } = await supabase
        .from('retention_policies')
        .insert({
          table_name: data.table_name,
          state: data.state === 'all' ? null : data.state,
          retention_years: data.retention_years,
          description: data.description || null,
          is_active: data.is_active
        });
      
      if (error) throw error;
      
      toast({
        title: "Success",
        description: "Retention policy created successfully",
      });
      
      return true;
    } catch (error) {
      console.error('Error creating retention policy:', error);
      toast({
        title: "Error",
        description: "Failed to create retention policy",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const onSubmitPolicy = async (values: RetentionPolicyFormValues) => {
    const success = await createPolicyMutation(values);
    if (success) {
      setIsAddDialogOpen(false);
    }
  };
  
  return {
    createPolicyMutation,
    isSubmitting,
    onSubmitPolicy
  };
}
